module.exports = __webpack_public_path__ + "media/ppc/quote-d474fdf1.png";